import { render, staticRenderFns } from "./RipaStatuteDialog.vue?vue&type=template&id=5d794721"
import script from "./RipaStatuteDialog.vue?vue&type=script&lang=js"
export * from "./RipaStatuteDialog.vue?vue&type=script&lang=js"
import style0 from "./RipaStatuteDialog.vue?vue&type=style&index=0&id=5d794721&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports